<template>
<div>
  <Alerts ref="alert"/>
  <Forms ref="frmSearch"
           title="PESQUISA DE REEMBOLSO VIAGEM"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="onClickSearch"
           v-on:New="onNew">
      <div class="form-group row">
          <label v-if="!detailsDire"  for="cbxInsure">Situação:</label>
          <div v-if="!detailsDire" class="input-group">
            <b-form-select v-model="form.situacao.value">
              <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  <option v-for="data in dataSituacao" :key="data.value" :value="data.value">{{data.text}}</option>
              </template>
            </b-form-select>
          </div>
          <label for="cbxInsure">Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          type="text"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
                          :debounceLength="2"
                          :formField="form.obraID"
                          v-on:search="onSearchObra"
                          v-on:changeCode="onChangeCodeObra"/>

          <div class="lote" v-if="tabIndex != true">
            <label for="cbxInsure">Lote:</label>
            <autocomplete-z ref="despesaLog"
                placeholder="Digite o nome do Lote"
                type="text"
                iconClass="fas fa-file-excel"
                :serializer="(despesaLog) => despesaLog.arquivo"
                :debounceLength="2"
                :formField="form.despesaLog"
                v-on:search="GetDespesaLog"
                v-on:changeCode="onChangeCodeDespesaLog"/>
          </div>

          <div class="lote" v-if="tabIndex == true">
            <label for="cbxInsure">Lote:</label>
            <autocomplete-z ref="descontoLog"
                placeholder="Digite o nome d Lote"
                type="text"
                iconClass="fas fa-file-excel"
                :serializer="(despesaLog) => despesaLog.nomeArquivo"
                :debounceLength="2"
                :formField="form.despesaLog"
                v-on:search="GetDespesaDescontoLog"
                v-on:changeCode="onChangeCodeDespesaDescontoLog"/>
          </div>

          <label for="txtInsured"> Responsável:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          placeholder="Digite o nome do Responsável"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="form.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
      </div>
      <div class="form-group row pt-2">
          <label for="cbxInsure">Regional:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-industry"></i></span>
            <b-form-input type="text"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px);border-right: 0px;"
                          :placeholder="'Código'"
                          v-model="form.secaoRH.value"
                          :size="form.secaoRH.maxlength"
                          :state="form.secaoRH.state"
                          @focus="onClearSection"
                          v-on:change="onChangeCodeSection"
            />
            <b-form-select v-model="form.secaoRHID.value"
                           :options="form.secaoRHID.options" >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
              <option v-for="data in  dataRh" :key="data.id" :value="data.id">{{data.nome}}</option>
            </b-form-select>
          </div>
        <div class="col-md-6 mt-2">
          <label for="txtCodePeople"><small v-show="form.dataInicioSolicitacao.required" class="text-danger">*</small>Inicio Solicitação:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataInicioSolicitacao"
                          ref="dataInicioSolicitacaoComp"
                          v-model="form.dataInicioSolicitacao.value"
                          :required="form.dataInicioSolicitacao.required"
                          :state="form.dataInicioSolicitacao.state" />
          </div>
        </div>
        <div class="col-md-6 mt-2">
          <label for="txtCodePeople"><small v-show="form.dataFimSolicitacao.required" class="text-danger">*</small>Fim Solicitação:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataFimSolicitacao"
                          ref="dataFimSolicitacaoComp"
                          v-model="form.dataFimSolicitacao.value"
                          :required="form.dataFimSolicitacao.required"
                          :state="form.dataFimSolicitacao.state" />
          </div>
        </div>
      </div>
      <template v-slot:FooterButtonLeft>
        <button type="button" class="btn btn-third btn-sm d-none" @click="onNew"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fas fa-plus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.New}}</span></button>
      </template>
    </Forms>
</div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../mixins/ExpenseMixin.js'
import ExpenseSearchForm from '../search/search-form.js'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import { loading } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ExpenseSearchData from '@/shared/models/business/employeeboardsearchmodel.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import Datepicker from 'vuejs-datepicker'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Newformserarch',
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      form: ExpenseSearchForm,
      formTeste: {
        situacao: null
      },
      data: ExpenseSearchData,
      en: en,
      es: es,
      ptBR: ptBR,
      dataSituacao: [],
      dataRh: []
    }
  },
  mounted () {
    this.onLoadAllSections()
    this.getEnum()
  },
  props: {
    detailsDire: {
      type: Boolean,
      required: false,
      default: false
    },
    tabIndex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AutocompleteZ,
    Datepicker
  },
  methods: {
    onClear () {
      this.$refs.obraRHTypeahead.clear()
      this.formTeste.situacao = null
      this.$refs.responsavelTypeahead.clear()
      this.$refs.despesaLog.clear()
      if (this.tabIndex === true) {
        localStoreHelper.prestacaoContas.descontoFolha(null)
      } else {
        localStoreHelper.prestacaoContas.reembolso(null)
      }
    },
    onClickSearch () {
      this.form.situacao.value = this.form.situacao.value !== null ? parseInt(this.form.situacao.value) : null
      this.$emit('search', this.form)
      if (this.tabIndex === true) {
        localStoreHelper.prestacaoContas.descontoFolha(this.form)
      } else {
        localStoreHelper.prestacaoContas.reembolso(this.form)
      }
    },
    onNew () {
      this.$emit('New')
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    getEnum () {
      loading.push()
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          this.dataRh = response.data.data
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    }

  }

}
</script>

<style>
.lote {
  width: 100%;
}
.serachForm{
  width: 250px;
  height: 30px;
  background: #008144;
  border-radius: 25px;
  color: white;
  border: none;
}
.serachForm:hover{
  background: #004d29;
}
.serachFormClean{
  width: 250px;
  height: 30px;
  border: none;
  background: #C3C3C3;
  color: black;
  border-radius: 25px;
}
.serachFormClean:hover{
  background: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/newformserarch/newformserarch.vue